import { useSyncExternalStore } from 'react';

/**
 * Whether Core has refused this build as older than it supports (`UNSUPPORTED_APP_VERSION`).
 * The apps then cover everything with "Update StrongerMemory", as the OE app does with
 * "Update App". Set from the api client (`configureApiClient({ onUnsupportedAppVersion })`);
 * only an update, or on the web a reload, clears it.
 */
let required = false;
const listeners = new Set<() => void>();

export function markUpdateRequired(): void {
  if (required) return;
  required = true;
  for (const listener of listeners) listener();
}

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function isUpdateRequired(): boolean {
  return required;
}

export function useUpdateRequired(): boolean {
  return useSyncExternalStore(subscribe, isUpdateRequired, isUpdateRequired);
}
